import { certificates, directorates } from "../../shared/catalog";
import type { CatalogResponse } from "../../shared/types";

const catalog: CatalogResponse = {
  directorates,
  certificates,
};

export const useCatalog = () => {
  return { catalog, error: null, loading: false };
};